import { render, staticRenderFns } from "./pondEdit.vue?vue&type=template&id=4d6d54fb&scoped=true&"
import script from "./pondEdit.vue?vue&type=script&lang=js&"
export * from "./pondEdit.vue?vue&type=script&lang=js&"
import style0 from "./pondEdit.vue?vue&type=style&index=0&id=4d6d54fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d54fb",
  null
  
)

export default component.exports